import React from 'react';

const VivendiusLogo = ({ className = '', size = 'medium', white = false }) => {
  const sizeClasses = {
    small: 'h-8',
    medium: 'h-12',
    large: 'h-16'
  };

  const logoSrc = white ? "/assets/vivendius_logo_white.png" : "/assets/vivendius_logo_official.png";

  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src={logoSrc} 
        alt="Vivendius Logo" 
        className={`${sizeClasses[size]} w-auto`}
        onError={(e) => {
          // Fallback to text logo if image fails to load
          e.target.style.display = 'none';
          e.target.nextSibling.style.display = 'block';
        }}
      />
      <div className={`font-bold text-xl ${white ? 'text-white' : 'text-purple-600'}`} style={{ display: 'none' }}>
        <span className={white ? 'text-white' : 'text-purple-800'}>Vivendius</span>
        <span className="text-yellow-500 ml-1">📍</span>
      </div>
    </div>
  );
};

export default VivendiusLogo;